import classNames from 'classnames';
import { ComponentType, ElementType, FunctionComponent } from 'react';

export const withClassName = <TProps extends { className?: string }>(
  Component: ElementType<TProps>,
  staticClassName: string,
  displayName?: string,
): FunctionComponent<TProps> => {
  const Comp = Component as ComponentType<TProps>;

  const ComponentWithClassName = ({ className, ...props }: TProps) => (
    <Comp
      className={classNames(staticClassName, className)}
      {...(props as TProps)}
    />
  );

  ComponentWithClassName.displayName =
    /* istanbul ignore next */
    displayName || Comp.displayName || Comp.name;

  return ComponentWithClassName;
};
